import React from "react";
import { Button, Input } from "reactstrap";
import CustomMultipleSelect from "../../../../../Shared/Components/Form/CustomMultipleSelect";

export default function HistoryFilters({
  handleTypeSelect,
  setDateFrom,
  setDateTo,
  handleApplyFilters,
  selectedTypes,
  dateFrom,
  dateTo,
  setPopoverOpen,
  handleBooleanFiltersButtonSelect,
  booleanFilters,
  handleUsersChange,
  users,
  handleClearFilters,
  usersSelected,
}) {
  return (
    <div className="p-2 w-100 d-flex justify-content-between">
      <div className="d-flex flex-column gap-1">
        {/* Primera fila: Filtros y fechas alineados */}
        <div className="d-flex align-items-justify gap-1">
          <div className="d-flex gap-1">
            {["Todos", "Notas"].map((type) => (
              <Button
                key={type}
                outline={!selectedTypes.includes(type)}
                color="primary"
                size="sm"
                className="p-2"
                onClick={() => handleTypeSelect(type.toLowerCase())}
              >
                {type}
              </Button>
            ))}
          </div>

          {/* Inputs de fecha compactos */}
          <div className="d-flex gap-1">
            <Input
              type="date"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              className="form-control-sm p-2"
              style={{ minWidth: "120px" }}
            />
            <span>a</span>
            <Input
              type="date"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              className="form-control-sm p-2"
              style={{ minWidth: "120px" }}
            />
          </div>
        </div>

        {/* Segunda fila: nuevos filtros alineados a la izquierda */}
        <div className="d-flex align-items-center gap-2">
          <div className="h-auto">
            <CustomMultipleSelect
              items={users}
              name={"users"}
              placeholder="Filtrar por usuario"
              customChangeHandler={handleUsersChange}
              item={{ users: usersSelected }}
              className="form-control-sm"
            />
          </div>

          {["Con archivos", "Con enlaces"].map((type) => (
            <Button
              key={type}
              outline={!booleanFilters.includes(type)}
              color="primary"
              size="sm"
              className="p-2 form-control-sm d-flex align-items-center justify-content-center"
              style={{
                whiteSpace: "nowrap",
                width: "120px",
                textAlign: "center",
              }}
              onClick={() => {
                const newFilterTypes = booleanFilters.includes(type)
                  ? booleanFilters.filter((t) => t !== type)
                  : [...booleanFilters, type];

                handleBooleanFiltersButtonSelect(newFilterTypes);
              }}
            >
              {type}
            </Button>
          ))}
        </div>
      </div>

      {/* Botones de acción */}
      <div className="d-flex flex-column gap-1">
        <Button
          color="primary"
          size="sm"
          className="p-2 w-100"
          onClick={handleApplyFilters}
        >
          Aplicar Filtros
        </Button>
        <Button
          color="secondary"
          outline
          size="sm"
          className="p-2 w-100"
          onClick={handleClearFilters}
        >
          Limpiar
        </Button>
        <Button
          color="danger"
          onClick={() => setPopoverOpen(false)}
          outline
          size="sm"
          className="p-2 w-100"
        >
          Cancelar
        </Button>
      </div>
    </div>
  );
}
